import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "es6-shim";
import { msalInstance } from "./service/msalConfig";

import { initMsal } from "./authProvider";
const DO_NOT_LOGIN = false;


initMsal(msalInstance);



